import { render, staticRenderFns } from "./RecordFeatureFlag.vue?vue&type=template&id=319f786d&"
import script from "./RecordFeatureFlag.vue?vue&type=script&lang=js&"
export * from "./RecordFeatureFlag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports